<template>
  <div class="bottom-box" :class="wrapClass">
    <div class="left-wrap">
    <!--
      <woot-button
        v-tooltip.top-end="$t('CONVERSATION.REPLYBOX.TIP_EMOJI_ICON')"
        :title="$t('CONVERSATION.REPLYBOX.TIP_EMOJI_ICON')"
        icon="emoji"
        emoji="😊"
        color-scheme="secondary"
        variant="smooth"
        size="small"
        @click="toggleEmojiPicker"
      />
      -->
      <file-upload
        ref="upload"
        v-tooltip.top-end="$t('CONVERSATION.REPLYBOX.TIP_ATTACH_ICON')"
        :size="4096 * 4096"
        :accept="allowedFileTypes"
        :multiple="enableMultipleFileUpload"
        :drop="true"
        :drop-directory="false"
        :data="{
          direct_upload_url: '/rails/active_storage/direct_uploads',
          direct_upload: true,
        }"
        @input-file="onFileUpload"
      >
        <woot-button
          v-if="showAttachButton"
          class-names="button--upload"
          :title="$t('CONVERSATION.REPLYBOX.TIP_ATTACH_ICON')"
          icon="attach"
          emoji="📎"
          color-scheme="secondary"
          variant="smooth"
          size="small"
        />
      </file-upload>
      <!-- <woot-button
        v-if="showAudioRecorderButton"
        v-tooltip.top-end="$t('CONVERSATION.REPLYBOX.TIP_AUDIORECORDER_ICON')"
        :icon="!isRecordingAudio ? 'microphone' : 'microphone-off'"
        emoji="🎤"
        :color-scheme="!isRecordingAudio ? 'secondary' : 'alert'"
        variant="smooth"
        size="small"
        @click="toggleAudioRecorder"
      /> -->

      <woot-button
        :key="'international-' + showCallButton"
        v-tooltip.top-end="$t(calltitle)"
        :icon="currentIcon"
        :tooltip="'For International Calls'"
        color-scheme="secondary"
        variant="smooth"
        size="small"
        @click="startupClient"
      />
      <woot-button
        v-for="inbox in jioEvaInboxes"
        v-if="inbox.inboxObject && inbox.inboxObject.name"
        :key="'domestic-' + inbox.value"
        color-scheme="primary"
        variant="smooth"
        size="small"
        @click="initializeDomesticCall(inbox.value)"
        v-tooltip.top-end="inbox.inboxObject.name"
        :title="inbox.inboxObject.name"
        class="domestic-call"
      >
        <fluent-icon 
          :icon="'jio'" 
          :viewBox="'1 2 25 20'" 
          :size="'25'" 
          class="insta-icon"
          style="display: block;"
        />
      </woot-button>
      <woot-button
        color-scheme="primary"
        variant="smooth"
        size="small"
        class="macro-button"
        @click="$emit('open-macros-panel')"
      >
        Macros
      </woot-button>
      <EmailSuggestionButton
        v-if="currentContact && currentContact.id && isAnEmailChannel"
        :contact-id="currentContact.id"
        @suggestion-generated="handleSuggestionGenerated"
      />
      <woot-button
        v-if="showEditorToggle"
        v-tooltip.top-end="$t('CONVERSATION.REPLYBOX.TIP_FORMAT_ICON')"
        icon="quote"
        emoji="🖊️"
        color-scheme="secondary"
        variant="smooth"
        size="small"
        @click="$emit('toggle-editor')"
      />

      <woot-button
        v-if="showAudioPlayStopButton"
        :icon="audioRecorderPlayStopIcon"
        emoji="🎤"
        color-scheme="secondary"
        variant="smooth"
        size="small"
        @click="toggleAudioRecorderPlayPause"
      >
        <span>{{ recordingAudioDurationText }}</span>
      </woot-button>

      <woot-button
        v-if="showMessageSignatureButton"
        v-tooltip.top-end="signatureToggleTooltip"
        icon="signature"
        color-scheme="secondary"
        variant="smooth"
        size="small"
        :class-names="signatureButtonClassNames"
        @click="toggleMessageSignature"
      />

      <woot-button
        v-if="showShopify"
        v-tooltip.top-end="shopifyTitle"
        :icon="shopifyIcon"
        color-scheme="secondary"
        variant="smooth"
        size="small"
        @click="fetchOrders"
      />

      <woot-button
        v-if="hasWhatsappTemplates"
        v-tooltip.top-end="'Whatsapp Templates'"
        icon="whatsapp"
        color-scheme="secondary"
        variant="smooth"
        size="small"
        :title="'Whatsapp Templates'"
        @click="$emit('selectWhatsappTemplate')"
      />
      <woot-button
        v-if="isAnEmailChannel && !isOnPrivateNote"
        v-tooltip.top-end="$t('CONVERSATION.REPLYBOX.TIP_EMAIL_TEMPLATES')"
        icon="mail"
        color-scheme="secondary"
        variant="smooth"
        size="small"
        :title="$t('CONVERSATION.REPLYBOX.TIP_EMAIL_TEMPLATES')"
        @click="$emit('selectEmailTemplate')"
      />
      <div
        v-if="showBotToggleButton"
        v-tooltip.top-end="fullBotToggleTooltip"
        class="bot-toggle-container"
        :class="{ 'bot-disabled': isBotDisabled }"
        @click.stop="handleToggleClick"
      >
        <woot-switch
          :value="!isBotDisabled"
          @input.stop="handleToggleSwitch"
          :disabled="isTogglingBot"
        >
          <template #thumb>
            <fluent-icon icon="bot" size="12" class="bot-toggle-container__thumb-icon" />
          </template>
        </woot-switch>
      </div>
      <div
        v-if="conversationId && !isOnPrivateNote && showBotToggleButton && isBotDisabled && isAiGenerateResponseSupported"
        v-tooltip.top-end="generateResponseLoading ? '' : $t('CONVERSATION.AI_GENERATE_RESPONSE.TITLE')"
        class="ai-generate-response-button-wrap"
        :class="{ 'ai-generate-response-button-wrap--loading': generateResponseLoading }"
      >
        <woot-button
          icon="bot"
          color-scheme="secondary"
          variant="smooth"
          size="small"
          class="ai-generate-response-button"
          :disabled="generateResponseLoading"
          @click="showGenerateResponseModal = true"
        />
      </div>
      <video-call-button
        v-if="(isAWebWidgetInbox || isAPIInbox) && !isOnPrivateNote"
        :conversation-id="conversationId"
      />
      <draggable-file
        :show="showDragmodal"
        :formatted="formattedTime"
        :hangup="CallHangup"
      />

      <woot-modal
        :show.sync="showFetchOrdersModal"
        :on-close="hideFetchOrdersModal"
      >
        <div class="p-4">
          <h2 class="text-xl font-bold mb-4">Shopify Orders</h2>
          <p v-if="isLoadingOrders" class="text-base text-center">Fetching orders<span class="spinner"></span></p>
          <div v-else>
             <AIAssistanceModal
                :ai-option="aiOption"
                @apply-text="insertText"
                @close="hideFetchOrdersModal"
                :orders="orders"
              />
            <!-- <ul v-if="orders.length > 0" class="space-y-4 list-none p-0">
              <li v-for="order in orders" :key="order.id" >
                <h3 class="text-lg font-semibold mb-2">Order #{{ order.id }}</h3>
                <p class="text-base mb-2">Total Price: {{ order.total_price }} {{ order.currency }}</p>
                <h4 class="text-base font-medium mb-2">Line Items:</h4>
                <ul class="list-disc pl-5">
                  <li v-for="item in order.line_items" :key="item.id" class="text-base mb-1">
                    <span class="font-medium">{{ item.name }}</span> - 
                    {{ item.price }} {{ item.currency }} x {{ item.quantity }}
                    (SKU: {{ item.sku }})
                  </li>
                </ul>
              </li>
            </ul> -->
            <!-- <p v-else class="text-base">No orders found.</p> -->
          </div>
        </div>
      </woot-modal>

      <generate-agent-response-modal
        :show.sync="showGenerateResponseModal"
        :conversation-id="conversationId"
        :loading="generateResponseLoading"
        :generated-content="generatedContentInModal"
        @submit="handleGenerateAgentSubmit"
        @send="handleGenerateAgentSend"
        @close="onGenerateAgentModalClose"
      />
      <!-- <AIAssistanceButton
        :conversation-id="conversationId"
        :is-private-note="isOnPrivateNote"
        :message="message"
        @replace-text="replaceText"
      /> -->
      <transition name="modal-fade">
        <div
          v-show="$refs.upload && $refs.upload.dropActive"
          class="fixed top-0 bottom-0 left-0 right-0 z-20 flex flex-col items-center justify-center w-full h-full gap-2 text-slate-900 dark:text-slate-50 bg-modal-backdrop-light dark:bg-modal-backdrop-dark"
        >
          <fluent-icon icon="cloud-backup" size="40" />
          <h4 class="page-sub-title text-slate-900 dark:text-slate-50">
            {{ $t('CONVERSATION.REPLYBOX.DRAG_DROP') }}
          </h4>
        </div>
      </transition>
    </div>
    <div class="right-wrap">
      <woot-button
        size="small"
        :class-names="buttonClass"
        :is-disabled="isSendDisabled"
        @click="onSend"
      >
        {{ sendButtonText }}
      </woot-button>
      <woot-modal :show.sync="showCallRecordingModal" :on-close="hideCallRecordingModal">
        <h4 class="domestic_call_heading mt-4 text-center">📞 Indian Domestic Call Recordings</h4>

        <div class="p-4" :style="{ maxHeight: '70vh', overflowY: 'auto' }">
          <p v-if="isLoadingRecordings" class="text-center text-muted">Loading recordings...</p>
          <p v-else-if="recordings.length === 0" class="text-center text-danger">No call recordings found.</p>

          <div v-else class="recordings-container">
            <div v-for="(recording, index) in recordings" :key="recording.id" class="call-card">
              <div class="call-header">
                <h6 style="color: white; font-weight: 400;">📂 Recording {{ index + 1 }}</h6>
              </div>

              <div class="call-info">
                <p><strong>📲 Caller:</strong> {{ recording.caller_number }}</p>
                <p><strong>📞 Callee:</strong> {{ recording.callee_number }}</p>
                <p><strong>⏳ Duration:</strong> {{ formatDuration(recording.call_duration) }}</p>
                <p><strong>🕒 Time:</strong> 
                  {{ new Date(recording.created_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }) }}
                </p>
                <p><strong>🔄 Call Type:</strong> 
                  <span>
                    {{ recording.call_back === 'false' ? 'Outgoing Call' : 'Incoming Call' }}
                  </span>
                </p>
              </div>

              <div class="call-audio">
                <template v-if="recording.audio_url">
                  <audio class="control" :src="recording.audio_url" controls></audio>
                </template>
                <template v-else>
                  <p class="text-warning"><strong>⚠️ Audio file is not available.</strong></p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </woot-modal>
    </div>
  </div>
</template>

<script src="//ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
<script type="text/javascript" src="twilio.min.js"></script>
<script>
import FileUpload from 'vue-upload-component';
import * as ActiveStorage from 'activestorage';
import { hasPressedAltAndAKey } from 'shared/helpers/KeyboardHelpers';
import eventListenerMixins from 'shared/mixins/eventListenerMixins';
import uiSettingsMixin from 'dashboard/mixins/uiSettings';
import twilioMixin from 'dashboard/mixins/twilioCall';
import inboxMixin from 'shared/mixins/inboxMixin';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import {
  ALLOWED_FILE_TYPES,
  ALLOWED_FILE_TYPES_FOR_TWILIO_WHATSAPP,
} from 'shared/constants/messages';
import VideoCallButton from '../VideoCallButton';
import AIAssistanceButton from '../AIAssistanceButton.vue';
import ConversationApi from '../../../api/inbox/conversation';
import { REPLY_EDITOR_MODES } from './constants';
import { mapGetters } from 'vuex';
import axios from 'axios';
import DraggableFile from './Draggable.vue';
import alertMixin from 'shared/mixins/alertMixin';
import AIAssistanceModal from '../AIAssistanceModal.vue';
import EmailSuggestionButton from '../EmailSuggestionButton.vue';
import WootSwitch from 'dashboard/components/ui/Switch.vue';
import GenerateAgentResponseModal from '../conversation/GenerateAgentResponseModal.vue';

let  token;
let device;
let call;

export default {
  name: 'ReplyBottomPanel',
  components: {
    EmailSuggestionButton,
    FileUpload,
    VideoCallButton,
    AIAssistanceButton,
    DraggableFile,
    AIAssistanceModal,
    WootSwitch,
    GenerateAgentResponseModal,
  },
  mixins: [
    eventListenerMixins,
    uiSettingsMixin,
    inboxMixin,
    twilioMixin,
    alertMixin,
  ],
  props: {
    mode: {
      type: String,
      default: REPLY_EDITOR_MODES.REPLY,
    },
    onSend: {
      type: Function,
      default: () => {},
    },
    sendButtonText: {
      type: String,
      default: '',
    },
    recordingAudioDurationText: {
      type: String,
      default: '',
    },
    inbox: {
      type: Object,
      default: () => ({}),
    },
    showFileUpload: {
      type: Boolean,
      default: false,
    },
    showAudioRecorder: {
      type: Boolean,
      default: false,
    },
    onFileUpload: {
      type: Function,
      default: () => {},
    },
    showEmojiPicker: {
      type: Boolean,
      default: false,
    },
    toggleEmojiPicker: {
      type: Function,
      default: () => {},
    },
    toggleAudioRecorder: {
      type: Function,
      default: () => {},
    },
    toggleAudioRecorderPlayPause: {
      type: Function,
      default: () => {},
    },
    isRecordingAudio: {
      type: Boolean,
      default: false,
    },
    recordingAudioState: {
      type: String,
      default: '',
    },
    isSendDisabled: {
      type: Boolean,
      default: false,
    },
    showEditorToggle: {
      type: Boolean,
      default: false,
    },
    isOnPrivateNote: {
      type: Boolean,
      default: false,
    },
    enableMultipleFileUpload: {
      type: Boolean,
      default: true,
    },
    hasWhatsappTemplates: {
      type: Boolean,
      default: false,
    },
    conversationId: {
      type: Number,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showCallButton: true,
      showDomesticCallButton: true,
      currentIcon: 'call-start',
      calltitle: 'CONVERSATION.REPLYBOX.CALL',
      showDragmodal: false,
      timerRunning: false,
      seconds: 0,
      minutes: 0,
      hours: 0,
      tooltipText: 'Domestic Call',
      shopifyTitle: 'Shopify', 
      shopifyIcon: 'shopify',
      showFetchOrdersModal: false,
      showGenerateResponseModal: false,
      generateResponseLoading: false,
      generatedContentInModal: '',
      orders: [], // To store the fetched orders
      isLoadingOrders: false, 
      showShopify: false,
      showShopifyId: false,
      aiOption: '',
      draftMessage: '',
      initialMessage: '',
      showCallRecordingModal: false,
      isLoadingRecordings: false,
      isMessage: false,
      message_info: "",
      recordings: [],
      jioEvaInboxes: [],
      isTogglingBot: false,
      inboxAgentBot: null,
    };
  },
  computed: {
    formattedTime() {
      return (
        this.pad(this.hours) +
        ':' +
        this.pad(this.minutes) +
        ':' +
        this.pad(this.seconds)
      );
    },
    ...mapGetters({
      currentChat: 'getSelectedChat',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      baseUrl: 'getbaseUrl',
      currentUser: 'getCurrentUser',
      currentUserId: 'getCurrentUserID',
      shopifyHookExists: 'getShopifyHookExists',
    }),
    currentContact() {
      return this.$store.getters['contacts/getContact'](
        this.currentChat.meta.sender.id
      );
    },
    currentAgent() {
      const { id, name, email } = this.$store.getters.getCurrentUser;
      return { id, name, email };
    },
    isNote() {
      return this.mode === REPLY_EDITOR_MODES.NOTE;
    },
    wrapClass() {
      return {
        'is-note-mode': this.isNote,
      };
    },
    buttonClass() {
      return {
        warning: this.isNote,
      };
    },
    showAttachButton() {
      return this.showFileUpload || this.isNote;
    },
    hideAIAssistanceModal() {
      return true;
    },
    showAudioRecorderButton() {
      // Disable audio recorder for safari browser as recording is not supported
      const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(
        navigator.userAgent
      );

      return (
        this.isFeatureEnabledonAccount(
          this.accountId,
          FEATURE_FLAGS.VOICE_RECORDER
        ) &&
        this.showAudioRecorder &&
        !isSafari
      );
    },
    showAudioPlayStopButton() {
      return this.showAudioRecorder && this.isRecordingAudio;
    },
    allowedFileTypes() {
      if (this.isATwilioWhatsAppChannel) {
        return ALLOWED_FILE_TYPES_FOR_TWILIO_WHATSAPP;
      }
      return ALLOWED_FILE_TYPES;
    },
    audioRecorderPlayStopIcon() {
      switch (this.recordingAudioState) {
        // playing paused recording stopped inactive destroyed
        case 'playing':
          return 'microphone-pause';
        case 'paused':
          return 'microphone-play';
        case 'stopped':
          return 'microphone-play';
        default:
          return 'microphone-stop';
      }
    },
    showMessageSignatureButton() {
      return !this.isOnPrivateNote && this.isAnEmailChannel;
    },
    sendWithSignature() {
      const { send_with_signature: isEnabled } = this.uiSettings;
      return isEnabled;
    },
    signatureToggleTooltip() {
      return this.sendWithSignature
        ? this.$t('CONVERSATION.FOOTER.DISABLE_SIGN_TOOLTIP')
        : this.$t('CONVERSATION.FOOTER.ENABLE_SIGN_TOOLTIP');
    },
    // Blue highlight class only when signature is on.
    signatureButtonClassNames() {
      return this.sendWithSignature ? 'message-signature-toggle--on' : '';
    },
    showBotToggleButton() {
      // Only show bot toggle button when inbox has a bot configured
      if (!this.conversationId || this.isOnPrivateNote) return false;
      return this.inboxAgentBot && this.inboxAgentBot.id;
    },
    // AI Generate Response only works with these bot types (must match backend InboxBotAgentMapping)
    supportedAiBotTypes() {
      return ['kivo_agent_external', 'w3villa_agent', 'kivo_eye_agent', 'crm_faq_agent', 'w3grads_faq_agent'];
    },
    isAiGenerateResponseSupported() {
      if (!this.inboxAgentBot || !this.inboxAgentBot.id) return false;
      const botType = this.inboxAgentBot.bot_type || '';
      return this.supportedAiBotTypes.includes(botType);
    },
    activeAgentBotName() {
      return this.inboxAgentBot?.name || 'Bot';
    },
    isBotDisabled() {
      const additionalAttributes = this.currentChat?.additional_attributes || {};
      return additionalAttributes.bot_disabled || false;
    },
    botToggleIcon() {
      return 'bot';
    },
    botToggleTooltip() {
      const botName = this.activeAgentBotName;
      return this.isBotDisabled 
        ? `${botName} is disabled - Click to enable` 
        : `${botName} is enabled - Click to disable`;
    },
    fullBotToggleTooltip() {
      // Always show full bot name in tooltip, even if truncated in button
      const botName = this.inboxAgentBot?.name || 'Bot';
      return this.isBotDisabled 
        ? `${botName} is disabled - Click to enable` 
        : `${botName} is enabled - Click to disable`;
    },
  },
  watch: {
    inbox: {
      handler(newInbox) {
        if (newInbox && newInbox.id) {
          this.fetchAgentBotForInbox();
        } else {
          this.inboxAgentBot = null;
        }
      },
      immediate: true,
    },
    conversationId: {
      handler() {
        if (this.inbox && this.inbox.id) {
          this.fetchAgentBotForInbox();
        }
      },
      immediate: false,
    },
  },
  mounted() {
    ActiveStorage.start();
    this.check_hook();
    this.initialMessage = this.draftMessage;
    console.log("Agent details current:", this.currentAgent.id);

    // this.fetchCurrentAssignee();
    this.fetchJioEvaInboxes();
    this.fetchAgentBotForInbox();
  },
  methods: {
    handleKeyEvents(e) {
      if (hasPressedAltAndAKey(e)) {
        this.$refs.upload.$children[1].$el.click();
      }
    },
    toggleMessageSignature() {
      this.updateUISettings({
        send_with_signature: !this.sendWithSignature,
      });
    },
    replaceText(text) {
      this.$emit('replace-text', text);
    },
    handleSuggestionGenerated(data) {
      this.$emit('suggestion-generated', data);
    },
    onGenerateAgentModalClose() {
      this.showGenerateResponseModal = false;
      this.generatedContentInModal = '';
    },
    async handleGenerateAgentSubmit({ query }) {
      if (!this.isAiGenerateResponseSupported) {
        this.showAlert(this.$t('CONVERSATION.AI_GENERATE_RESPONSE.BOT_NOT_SUPPORTED'));
        return;
      }
      this.generateResponseLoading = true;
      try {
        const response = await ConversationApi.generateAiContent(this.conversationId, {
          query: query || undefined,
        });
        const success = response.data?.success === true;
        const fullText = response.data?.response ?? '';
        if (success && fullText) {
          if (this.showGenerateResponseModal) {
            this.generatedContentInModal = fullText;
          }
        } else {
          this.showAlert(this.$t('CONVERSATION.AI_GENERATE_RESPONSE.SOMETHING_WENT_WRONG'));
        }
      } catch (_error) {
        this.showAlert(this.$t('CONVERSATION.AI_GENERATE_RESPONSE.SOMETHING_WENT_WRONG'));
      } finally {
        this.generateResponseLoading = false;
      }
    },
    handleGenerateAgentSend({ content }) {
      if (content) {
        this.$emit('send-agent-content', { content });
      }
      this.generatedContentInModal = '';
      this.showGenerateResponseModal = false;
    },

    async toggleBotStatus() {
      const botName = this.activeAgentBotName;
      const confirmMessage = this.isBotDisabled
        ? `Are you sure you want to enable ${botName} for this conversation?`
        : `Are you sure you want to disable ${botName} for this conversation?`;

      if (!window.confirm(confirmMessage)) return;

      this.isTogglingBot = true;
      try {
        const response = await this.$store.dispatch('toggleBot', this.conversationId);
        if (response.success) {
          this.showAlert(response.message);
        }
      } catch (error) {
        this.showAlert('Failed to toggle bot status. Please try again.');
      } finally {
        this.isTogglingBot = false;
      }
    },

    handleToggleClick(event) {
      // Prevent event bubbling and handle toggle
      event.stopPropagation();
      if (!this.isTogglingBot) {
        this.toggleBotStatus();
      }
    },

    handleToggleSwitch(value) {
      // Handle switch input event
      if (!this.isTogglingBot) {
        this.toggleBotStatus();
      }
    },

    async fetchAgentBotForInbox() {
      if (this.inbox && this.inbox.id && this.currentUser?.access_token) {
        try {
          const response = await axios.get(
            `/api/v1/accounts/${this.accountId}/inboxes/${this.inbox.id}/agent_bot`,
            {
              headers: {
                'api-access-token': this.currentUser.access_token,
              },
            }
          );
          // Check if agent_bot exists and has an id
          const agentBot = response.data?.agent_bot;
          this.inboxAgentBot = (agentBot && agentBot.id) ? agentBot : null;
        } catch (error) {
          // Silently fail - bot info not available
          this.inboxAgentBot = null;
        }
      }
    },

    // Outgoing Call
    async updateUIAcceptedOutgoingCall() {
      this.startTimer();
    },

    async updateUIDisconnectedOutgoingCall() {
      alert('Call Ended');
      this.showDragmodal = false;
      this.resetTimer();
      console.log('::::::::::::Call has ended::::::::::');
      window.call = null
    },

    async makeOutgoingCall() {
      try {
        const contact = this.currentContact;
        console.log('Contact', contact);
        let inbox_id = contact.contact_inboxes[0].inbox.id;
        var params = {
          To: contact.phone_number,
          account_id: this.accountId,
          contact_id: contact.id,
          inbox_id: inbox_id,
          userId: this.currentUserId,
        };
        if (device) {
          console.log(`Attempting to call ${params.To} ...`);
          call = await device.connect({ params });
          window.call = call
          call.on('accept', this.updateUIAcceptedOutgoingCall);
          call.on('disconnect', this.updateUIDisconnectedOutgoingCall);
          call.on('cancel', this.updateUIDisconnectedOutgoingCall);
        } else {
          console.log('Unable to make call.');
        }
      } catch (error) {
        console.error(
          'Error making outgoing call:-------------------------',
          error
        );
      }
    },

    formatDuration(seconds) {
      if (!seconds || seconds < 0) return "0 seconds";

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;

      let durationString = [];

      if (hours > 0) durationString.push(`${hours} hour${hours > 1 ? 's' : ''}`);
      if (minutes > 0) durationString.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
      if (remainingSeconds > 0 || durationString.length === 0)
        durationString.push(`${remainingSeconds} second${remainingSeconds > 1 ? 's' : ''}`);

      return durationString.join(", ");
    },
    async CallHangup() {
      console.log('Call Disconnected');
      // call.disconnect();
      if(call){
        call.disconnect();
        window.call = null
      }
      this.$store.dispatch('contacts/toggleholdCallAvailableStatusFalse');
    },

    async getAudioDevices() {
      try {
        console.log('Inside getAudioDevices::::::::::::::::::::');
        await navigator.mediaDevices.getUserMedia({ audio: true });
           return true; // Mic allowed
        } catch (error) {
        return false; // Mic denied or error
      }
    },

    addDeviceListeners(device) {
      device.on('registered', function () {
        console.log('Twilio.Device Ready to make and receive calls!');
      });
      device.on('error', function (error) {
        console.log('Twilio.Device Error: ' + error.message);
      });
    },

    async intitializeDevice() {
      console.log('Initializing device');
      device = new Twilio.Device(token, {
        logLevel: 1,
      });
      this.addDeviceListeners(device);
      device.register();
    },

    async fetchCurrentAssignee() {
      try {
        const response = await axios.get(
          `/api/v1/accounts/${this.accountId}/conversations/${this.conversationId}/messages/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.currentUser.access_token,
            },
          }
        );

        const assignee = response.data.meta.assignee;

        if (assignee && assignee.id) {
          console.log("Fetched Assignee ID:", assignee.id);
          return assignee.id; // Return only the ID
        } else {
          console.error("No assignee found in response.");
          return null; // Return null if no ID is found
        }
      } catch (error) {
        console.error("Error fetching current assignee:", error);
        return null; // Return null in case of error
      }
    },

    async fetchJioEvaInboxes() {
      console.log('Fetching JioEva inboxes...', this);

      try {
        const response = await axios.get(
          `/domestic_calls/jio_inboxes?account_id=${this.accountId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.$store.getters.getCurrentUser.access_token,
            },
          }
        );

        this.jioEvaInboxes = response.data
          .filter(item => item.channel_type === 'Channel::JioEva')
          .map(item => ({
            label: item.name,
            value: item.id,
            inboxObject: item
          }));

        console.log('JioEva inboxes:', this.jioEvaInboxes);

      } catch (error) {
        console.error('Error fetching JioEva inboxes:', error);
        this.jioEvaInboxes = [];
        this.showAlert('Failed to fetch JioEva inboxes. Please try again later.');
      }
    },

    async initializeDomesticCall(inbox_id) {
      try {
        // const assigneeId = await this.fetchCurrentAssignee();

        // if (!assigneeId) {
        //   console.error("Cannot proceed without a valid assignee ID.");
        //   alert("Failed to initialize the call due to missing assignee information.");
        //   return;
        // }

        const contact = this.currentContact;

        console.log('Contact info :', contact);
        const target_inbox_id = this.inbox.id;
        const url = `${this.baseUrl}/domestic_calls/create_call`;
        const body = {
          phone_number: contact.phone_number,
          account_id: this.accountId,
          inbox_id: inbox_id,
          target_inbox_id: target_inbox_id,
          agent_id: this.currentUser.id,
          conversation_id: this.conversationId,
          display: true
        };

        const response = await axios.post(url, body);
        alert(response.data.message);
      } catch (error) {
        console.error("Error initializing domestic call:", error);
      }
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      return new Date(dateString).toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
      });
    },
    async toggleCallRecording() {
      this.showCallRecordingModal = true;
      this.isLoadingRecordings = true;

      try {
        const response = await axios.get(`/domestic_calls/call_recordings?conversation_id=${this.conversationId}&account_id=${this.accountId}&inbox_id=${this.inbox.id}`);
        this.recordings = response.data.call_recordings || [];
        this.message_info = response.data.message || "";
        this.isMessage = !!this.message_info;
      } catch (error) {
        console.error('Error fetching call recordings:', error);
        this.message_info = "Failed to fetch call recordings. Please try again.";
        this.isMessage = true;
      } finally {
        this.isLoadingRecordings = false;
      }
    },

    hideCallRecordingModal() {
      this.showCallRecordingModal = false;
    },

    async startupClient() {
      console.log('Requesting Access Token...');
      const contact = this.currentContact;
      console.log('contact::::', contact);
      let data; // Declare data variable outside the try block
      
      // Request microphone permission FIRST before opening modal
      const hasPermission = await this.getAudioDevices();
      if (!hasPermission) {
        this.showAlert('Please allow access to your microphone in the browser to make a call.');
        return;
      }
      
      try {
        this.$store.dispatch('contacts/toggleholdCallAvailableStatusTrue');
        this.showDragmodal = !this.showDragmodal;
        console.log('Contact in yourMethod:', contact);
        console.log('User Id', this.currentUserId);
        // Remove redeclaration of data variable here
        const response = await axios.get(`${this.baseUrl}/twilio/token`, {
          params: {
            To: contact.phone_number,
            account_id: this.accountId,
            user_id: this.currentUserId,
          },
        });
        data = response.data;

        token = data.token;
        console.log('got token' + token);
        await this.intitializeDevice();
        this.makeOutgoingCall();
      } catch (err) {
        this.showAlert(data.message);
        this.showDragmodal = !this.showDragmodal;
        console.log(
          'An error occurred. See your browser console for more information.'
        );
      }
    },

    async fetchOrders() {
      this.showFetchOrdersModal = true;
      this.isLoadingOrders = true;
      this.orders = []; // Clear previous orders
      try {
        const response = await axios.post(
          `/api/v1/accounts/${this.accountId}/integrations/hooks/${this.showShopifyId}/process_event`,
          {
            event: {
              data: {
                conversation_display_id:  this.conversationId,
                name: "reply_suggestion"
              },
              id: this.showShopifyId,
              account_id: this.account_id,
            }
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.currentUser.access_token,
            },
          }
        );
        // Process orders one by one
        // for (const order of response.data.orders) {
        //   const processedOrder = {
        //     id: order.id,
        //     total_price: order.line_items.reduce((sum, item) => sum + parseFloat(item.price), 0).toFixed(2),
        //     currency: order.line_items[0]?.price_set?.shop_money?.currency_code || 'Unknown',
        //     line_items: order.line_items.map(item => ({
        //       id: item.id,
        //       name: item.name,
        //       price: item.price,
        //       sku: item.sku,
        //       quantity: item.quantity,
        //       currency: item.price_set?.shop_money?.currency_code || 'Unknown',
        //     })),
        //   };
        //   this.orders.push(processedOrder);
        //   // Force Vue to update the view after each order is added
        //   await this.$nextTick();
        // }

        if(response.data.message){
          this.orders = response.data.message;
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
        this.showAlert('Failed to fetch orders. Please try again.');
      } finally {
        this.isLoadingOrders = false;
      }
    },
    insertText(message) {
      this.$emit('replace-text', message);
    },
    async hideFetchOrdersModal() {
      // Hide the modal when closed
      this.showFetchOrdersModal = false;
    },
    async check_hook() {
      try {
        const response = await axios.get(
          `/api/v1/accounts/${this.accountId}/check_shopify_hook`,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.currentUser.access_token
            },
          }
        );
        console.log(response);
        this.showShopify = response.data.hook_exists;
        if(this.showShopify){
          this.showShopifyId=response.data.hook.id;
        }
      } catch (error) {
        console.error('Error checking Shopify hook:', error);
        this.showAlert('Failed to check Shopify hook. Please try again.');
      }
    },

    startTimer() {
      this.timerRunning = true;
      this.timer = setInterval(this.updateTimer, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
      console.log('Stop timer', this.timer);
      this.timerRunning = false;
    },
    updateTimer() {
      console.log('UpdateTimer:::::::');
      this.seconds++;
      if (this.seconds === 60) {
        this.seconds = 0;
        this.minutes++;
        if (this.minutes === 60) {
          this.minutes = 0;
          this.hours++;
        }
      }
    },
    pad(value) {
      return value < 10 ? '0' + value : value;
    },
    resetTimer() {
      this.stopTimer();
      this.seconds = 0;
      this.minutes = 0;
      this.hours = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.domestic-call {
  color: white;
  background-color: #3d3dc9;
}
.call-recording{
  font-size: 17px; 
  padding: 8px;
  color: white !important;
  background-color: hsl(209 100% 60.6% / 1) !important;
}
.domestic_call_heading{
  margin: 10px;
}
.bottom-box {
  @apply flex justify-between py-3 px-4;

  &.is-note-mode {
    @apply bg-yellow-100 dark:bg-yellow-800;
  }
}

.left-wrap {
  @apply items-center flex gap-2;
}

.ai-generate-response-button-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
}

/* When loading, only the modal Generate button shows a loader; reply-section icon stays static */
.ai-generate-response-button-wrap--loading {
  cursor: wait;
  pointer-events: none;
}

/* Generate AI Response icon always blue */
.ai-generate-response-button-wrap .ai-generate-response-button :deep(svg),
.ai-generate-response-button-wrap .ai-generate-response-button {
  color: var(--w-500);
}

// Enabled-signature highlight; matches EmailSuggestionButton blue.
// `!important` overrides .button.smooth.secondary hover/focus from
// scss/widgets/_buttons.scss which has equal specificity.
:deep(.button.message-signature-toggle--on),
:deep(.button.message-signature-toggle--on:hover),
:deep(.button.message-signature-toggle--on:focus),
:deep(.button.message-signature-toggle--on:active) {
  background-color: #1f93ff !important;
  color: #fff !important;

  .icon,
  svg {
    color: #fff !important;
  }
}

:deep(.button.message-signature-toggle--on:hover:not(:disabled)) {
  background-color: #007ef3 !important;
}

.right-wrap {
  @apply flex;
}

:deep(.file-uploads) {

  label {
    @apply cursor-pointer;
  }

  &:hover button {
    @apply dark:bg-slate-800 bg-slate-100;
  }
}

.icon {
  @apply text-[5rem];
}
.recordings-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.call-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 15px;
  transition: transform 0.2s ease-in-out;
}

.call-card:hover {
  transform: scale(1.02);
}

.call-header {
  background: #007bff;
  color: white;
  padding: 2px 12px;
  border-radius: 6px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 10px;
}

.call-info p {
  margin: 5px 0;
  font-size: 14px;
}

.call-audio {
  margin-top: 10px;
  text-align: center;
}
.control{
  width: 100%;
}
.message-box {
  background-color: #e0f2ff;
  color: #007bff;
  font-size: 16px;
  font-weight: bold;
  padding: 10px 15px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.bot-toggle-container {
  display: inline-flex;
  align-items: center;
  padding: 4px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  margin-top: 1px !important;

  &__thumb-icon {
    color: var(--w-500);
    pointer-events: none;
  }

  /* Bot icon black when toggle is off, blue when on */
  &.bot-disabled &__thumb-icon {
    color: #334155;
  }

  .dark &.bot-disabled &__thumb-icon,
  body.dark &.bot-disabled &__thumb-icon {
    color: #94a3b8;
  }

  &.bot-disabled {
    opacity: 0.7;
  }

  :deep(.toggle-button) {
    width: 48px !important;
    height: 25px !important;
    cursor: pointer;
    border-radius: 17px !important;

    span {
      width: 21px !important;
      height: 21px !important;
    }

    &.active span {
      transform: translate(22px, 0) !important;
    }
  }
}

</style>